import mutations from './mutations'
// import actions from './actions'

const state = {
	isNext:false,
	isSubmit:false,
	sendObj:[],//发作业课文预习
	releaseid:[],  	//作业预览发布作业的数据
	chapterid:[], //章节id
	picList:[],//图片数组
	btnColor:{
		background: '#6c2'
	},//按钮颜色
};


export default {
	state,
	mutations
}